var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"transform"},[_c('div',{staticClass:"transform_top"},[_vm._v("提现记录")])])
}]

export { render, staticRenderFns }